import type { BlockLayoutProps } from '@dcentralexpedientedigital/fe-ui/components/block-layout/block-layout';

export interface ComponentBlock {
    name: string;
    spanCols?: number;
    spanColsOnBreak?: number;
    properties: Record<string, unknown>;
}

export interface ComponentBlockWithSpacing extends ComponentBlock {
    spacing: BlockLayoutProps['spacing'];
}

export function isComponentBlock(block: unknown): block is ComponentBlock {
    return !!block && typeof block === 'object' && 'name' in block;
}

export function hasSpacing(block: ComponentBlock): block is ComponentBlockWithSpacing {
    return 'spacing' in block && typeof block.spacing === 'object';
}
